import { MutationTree } from 'vuex';
import { IAddResourceState } from './add-resource.types';
import { EAddResourceMutation } from './add-resource.constants';
import { IResource } from '@/api/resources/types/resource';

export const mutations: MutationTree<IAddResourceState> = {
  [EAddResourceMutation.SetAdding](state: IAddResourceState, adding: boolean) {
    state.adding = adding;
  },
  [EAddResourceMutation.SetResource](state: IAddResourceState, resource: IResource) {
    state.resource = resource;
  },
  [EAddResourceMutation.SetDocumentId](state: IAddResourceState, documentId: string) {
    state.documentId = documentId;
  },
  [EAddResourceMutation.SetState](state: IAddResourceState, newState: IAddResourceState) {
    state.adding = newState.adding;
    state.resource = newState.resource;
  },
};
